import React, { useState } from "react";
import "./TodoCard.css";
import { FaEdit, FaTrash, FaCheckCircle, FaClock, FaCalendarAlt } from "react-icons/fa";

const TodoCard = ({ todo, onEdit, onDelete, onToggleStatus }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    setTimeout(() => {
      onDelete(todo._id);
    }, 300);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return `${Math.floor(diffDays / 30)} months ago`;
  };

  return (
    <div className={`todo-card ${todo.isCompleted ? "completed" : ""} ${isDeleting ? "deleting" : ""}`}>
      {/* Background Decoration */}
      <div className="card-decoration"></div>
      
      {/* Status Badge */}
      <div className="status-badge-wrapper">
        <button
          className={`status-badge ${todo.isCompleted ? "badge-complete" : "badge-incomplete"}`}
          onClick={() => onToggleStatus(todo)}
          title={todo.isCompleted ? "Mark as incomplete" : "Mark as complete"}
        >
          {todo.isCompleted ? (
            <>
              <FaCheckCircle className="badge-icon" />
              <span>Completed</span>
            </>
          ) : (
            <>
              <FaClock className="badge-icon" />
              <span>In Progress</span>
            </>
          )}
        </button>
      </div>

      {/* Card Header */}
      <div className="todo-card-header">
        <h3 className="todo-title">{todo.title}</h3>
      </div>

      {/* Card Body */}
      <div className="todo-card-body">
        <p className="todo-desc">{todo.description}</p>
      </div>

      {/* Card Footer */}
      <div className="todo-card-footer">
        <div className="todo-meta">
          <div className="meta-item" title={formatDate(todo.createdAt)}>
            <FaCalendarAlt className="meta-icon" />
            <span className="meta-text">{getTimeAgo(todo.createdAt)}</span>
          </div>
        </div>

        <div className="todo-card-actions">
          <button 
            className="action-btn edit-btn" 
            onClick={() => onEdit && onEdit(todo)}
            title="Edit task"
          >
            <FaEdit className="action-icon" />
            <span className="action-label">Edit</span>
          </button>
          <button 
            className="action-btn delete-btn" 
            onClick={handleDelete}
            title="Delete task"
          >
            <FaTrash className="action-icon" />
            <span className="action-label">Delete</span>
          </button>
        </div>
      </div>

      {/* Completion Overlay */}
      {todo.isCompleted && (
        <div className="completion-overlay">
          <div className="completion-checkmark">✓</div>
        </div>
      )}
    </div>
  );
};

export default TodoCard;